import { ChevronDown } from "lucide-react";
import { type ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { useBrand } from "src/hooks/useBrand";

export function ConsentFaq(): ReactElement {
  const { t } = useTranslation();
  const { identity, customerPortal } = useBrand();

  return (
    <section
      className="consent-platform-faq"
      aria-labelledby="consent-faq-title"
    >
      <h2 id="consent-faq-title">{t("Vos questions fréquentes")}</h2>
      <details>
        <summary>
          <h3>{t("Que se passe-t-il si je refuse tout ?")}</h3>
          <ChevronDown aria-hidden="true" />
        </summary>
        <p>
          {t(
            "Vous continuerez à recevoir uniquement les communications strictement nécessaires liées à votre contrat (avis d'échéance, quittances, convocations d'AG, attestations…). En revanche, vous ne recevrez plus aucun conseil personnalisé, alerte immobilière, offre partenaire ni invitation à nos événements.",
          )}
        </p>
      </details>
      <details>
        <summary>
          <h3>{t("À quelle fréquence vais-je être contacté ?")}</h3>
          <ChevronDown aria-hidden="true" />
        </summary>
        <p>
          {t(
            "La fréquence dépend des finalités acceptées et de leur actualité. En moyenne 1 à 2 communications par mois, hors actualités exceptionnelles. Vous pourrez ajuster la fréquence dans votre espace {{portalName}}.",
            {
              portalName: customerPortal.name,
            },
          )}
        </p>
      </details>
      <details>
        <summary>
          <h3>
            {t(
              "Comment {{brandName}} choisit-il les communications qui me sont envoyées ?",
              {
                brandName: identity.name,
              },
            )}
          </h3>
          <ChevronDown aria-hidden="true" />
        </summary>
        <p>
          {t(
            "Nos communications sont adaptées à votre profil (locataire, copropriétaire, bailleur…), à votre situation et à vos centres d'intérêt. Plus votre profil est complet, plus les messages reçus sont pertinents — et moins vous êtes sollicité inutilement.",
          )}
        </p>
      </details>
    </section>
  );
}
